import * as EJS from 'exceljs';

import * as hm from './_hm';
import * as ht from './_ht';

export const addSht = (
  wbk: ht.o,
  shtName: ht.s,
): ht.o => {
  return wbk.addWorksheet(shtName);
};

export const crtWbk = () => {
  return new EJS.Workbook();
}


export const dldWbkAsync = async ( // download workbook
  wbk: ht.o,
  fileName: ht.s,
) => {
    const _uint8Array = await wbk.xlsx.writeBuffer()
    const _blob = new Blob([_uint8Array], { type: "application/octet-binary" });
    const _url = window.URL.createObjectURL(_blob);
    const _a = document.createElement("a");
    _a.href = _url;
    _a.download = fileName; //フォーマットによってファイル拡張子を変えている
    _a.click();
    _a.remove();
};

export const dltSht = ( // delete
  wbk: ht.o,
  shtName: ht.s,
): ht.o => {
  wbk.removeWorksheet(shtName);
};

export const fitPageW = (
  wst: ht.o, 
) => {
  wst.pageSetup.fitToPage = true
  wst.pageSetup.fitToWidth = 1
  wst.pageSetup.fitToHeight = 0;
};

export const grtSht = async (
  wbk: ht.o,
  shts:{
    shtName: ht.s,
    hdrs: ht.ls,
    bdys: ht.ls,
  }[],
) => {
  shts.map( _shtz => {
    const _wst = wbk.addWorksheet(_shtz.shtName);
    _wst.columns = _shtz.hdrs;
    _wst.addRows(_shtz.bdys);
  });
};

export const mrgCells = (
  wst: ht.o,
  row1: ht.n,
  cmn1: ht.n,
  row2: ht.n,
  cmn2: ht.n,
) => {
  wst.mergeCells(row1, cmn1, row2, cmn2);
};

export const readAsync = async (
  fileName: ht.s
) => {
  const _wbk = new EJS.Workbook();
  await _wbk.xlsx.readFile(fileName);
  return _wbk;
};

export const saveAsync = async (pd: { // ld_hdrss, ld_bdyss を lld_isss でひとまとめに定義したい
  fileName: ht.s,
  shts: {
    shtName: ht.s,
    hdrs: ht.ls,
    bdys: ht.ls,
  }[],
}) => {
  const _wbk = crtWbk();
  grtSht(_wbk, pd.shts);
  await dldWbkAsync(_wbk, pd.fileName)
};

export const setAmt = ( // alignment
  wst: ht.o, 
  row: ht.n, 
  cmn: ht.n, 
  vlez: ht.dz // { vertial: 'middle', horizontal: 'center', wrapText: true }
) => {
  wst.getCell(row, cmn).alignment = vlez;
}

export const setBdr = ( // border
  wst: ht.o, 
  row: ht.n, 
  cmn: ht.n, 
  vlez: ht.dz // { bottom: { style: 'thin', color: { argb: '000000' } }, }
) => {
  wst.getCell(row, cmn).border = vlez;
}

export const setFont = (
  wst: ht.o, 
  row: ht.n, 
  cmn: ht.n, 
  vlez: ht.dz // { name: 'メイリオ', size: 22, bold: true }
) => {
  wst.getCell(row, cmn).font = vlez;
}

// set formula
export const setFml = (
  wst: ht.o, 
  row: ht.n, 
  cmn: ht.n, 
  fml: ht.s
) => {
  wst.getCell(row, cmn).value = { formula: fml };
};

export const setFmt = (
  wst: ht.o, 
  row: ht.n, 
  cmn: ht.n, 
  vle?: ht.s // '#,##0;-#,##0'
) => {
  if (vle) wst.getCell(row, cmn).numFmt = vle;
}

export const setH = (
  wst: ht.o,
  row: ht.n,
  h: ht.n
) => {
  wst.getRow(row).height = h;
};

export const setImg = (
  wbk: ht.o, 
  wst: ht.o, 
  row: ht.n, 
  cmn: ht.n, 
  fileName: ht.s
) => {
  const _img = wbk.addImage({
    filename: fileName,
    extension: 'png',
  });
  wst.addImage(_img, { tl: { row: row - 1, col: cmn - 1 }, ext: { width: 80, height: 80 } });
}

export const setPrtArea = (
  wst: ht.o,
  vle: ht.s
) => {
  wst.pageSetup.printArea = vle;
};

export const setVle = (
  wst: ht.o, 
  row: ht.n, 
  cmn: ht.n, 
  vle: ht.s | ht.n
) => {
  wst.getCell(row, cmn).value = vle;
};

export const setW = (
  wst: ht.o,
  cmn: ht.n,
  w: ht.n
) => {
  wst.getColumn(cmn).width = w;
};

export const wrtAsync = async (
  wbk: ht.o,
  fileName: ht.s,
) => {
  await wbk.xlsx.writeFile(fileName)
};


/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
